namespace TabAurous.Production {
    export interface ProductionRow {
        TransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        VoucherNo?: string;
        ProcessId?: number;
        DepartmentId?: number;
        UserId?: number;
        Username?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        CompanyId?: number;
        ItemDetails?: ProductionItemsRow[];
    }

    export namespace ProductionRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Production.Production';
        export const deletePermission = 'Production:Production:Delete';
        export const insertPermission = 'Production:Production:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:Production:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            ProcessId = "ProcessId",
            DepartmentId = "DepartmentId",
            UserId = "UserId",
            Username = "Username",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            CompanyId = "CompanyId",
            ItemDetails = "ItemDetails"
        }
    }
}
